import { useSyncExternalStore } from 'react';
import { createClient } from '../lib/orpc.js';
import { createSessionManager } from './session-store.js';

/**
 * The composition root for the parent's session.
 *
 * The one file that reads a clock (AGENTS.md §3.1). It no longer touches
 * storage at all: the refresh token is an httpOnly cookie, so the browser holds
 * the only durable credential and nothing here can read it.
 */

/** Unauthenticated by design: this is the client that mints credentials. */
const authClient = createClient();

export const sessionManager = createSessionManager({
  authApi: authClient.auth,
  now: () => Date.now(),
});

/** Registration and sign-in. Neither has a token to send. */
export const authApi = authClient.auth;

export const useSession = () =>
  useSyncExternalStore(sessionManager.subscribe, sessionManager.current);
